if (!customElements.get("collection-logos")) {
    customElements.define(
      "collection-logos",
      class CollectionLogos extends HTMLElement {
        constructor() {
          super();
          this.init();
        }
  
        init() {
            const _this = this;
          const logosItems = this.querySelectorAll(".collection-logos-item-img");
          const logosItemText = this.querySelectorAll(
            ".collection-logos-item-text"
          );
          const logosTextWard = this.querySelectorAll('.collection-logos-text-ward')
  
          logosItems.forEach((item, index) => {
            if (index === 0 && _this.getWinClientWidth() > 768) {
              _this.updateSlider(item);
              _this.activeText(logosTextWard[index],logosTextWard)
  
            }
            item.onclick = () => {
              if (_this.getWinClientWidth() <= 768) {
                $(logosItemText).not($(item).next()).slideUp(300);
                $(logosItems).not($(item)).removeClass("active");
                $(item).toggleClass("active").next().slideToggle(300);
              } else {
              _this.activeText(logosTextWard[index],logosTextWard)
                _this.updateSlider(item);
              }
            };
          });
        }
  
        activeText(item,logosTextWard){
          $(logosTextWard).not($(item)).removeClass('active')
          $(item).addClass('active')
        }
  
        updateSlider(item) {
          const { offsetLeft, offsetWidth } = item;
          $(".collection-logos-content").css({
            ["--offsetLeft"]: offsetLeft + "px",
            ["--offsetWidth"]: offsetWidth + "px",
          });
        }
  
        getWinClientWidth() {
          return (
            document.documentElement.clientWidth || document.body.clientWidth
          );
        }
      }
    );
  }
  